import { WorldFC } from 'components/World';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { updateWorldParams } from 'store/actions';
import { APARTMENT_SCENE_ID, APARTMENT_GROUP_ID } from 'consts/building';

const CanHoMauPage = (props) => {
  const dispatch = useDispatch();
  const scenes = useSelector((state) => state.json?.scenes || []);

  const defaultApartmentScene = scenes.find(
    (scene) => scene._id === APARTMENT_SCENE_ID
  );

  useEffect(() => {
    const groupId = defaultApartmentScene?.groupId || APARTMENT_GROUP_ID;
    const sceneId = defaultApartmentScene?._id || APARTMENT_SCENE_ID;

    dispatch(
      updateWorldParams({
        groupId,
        sceneId,
      })
    );
  }, [dispatch, defaultApartmentScene]);

  return <WorldFC />;
};

export default CanHoMauPage;